import type { VendorIdentityState } from '../slices/vendorIdentitySlice.ts';
import type { VendorIdentityScope } from '../thunks/vendorIdentityThunks.ts';

export const selectVendorIdentity = (state: { vendorIdentity: VendorIdentityState }) => state.vendorIdentity;
export const selectVendorId = (state: { vendorIdentity: VendorIdentityState }, scope?: VendorIdentityScope) => {
  const identity = state.vendorIdentity;
  if (scope && (scope.userName !== identity.scope?.userName || scope.sessionKey !== identity.scope?.sessionKey)) return null;
  return identity.status === 'resolved' ? identity.vendorId : null;
};